import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'modifylc_change_trip';
export const route = 'modifylc_change_trip/[[...params]]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "modifylc_change_trip" */
/* webpackPrefetch: true */
'../components/ChangeTripLCPage')));